// @flow
import { Component } from "react";
import ReactDOM from "react-dom";

type Props = {
  modal: any,
  children: any
};

class renderModal extends Component<Props> {
  el: any;
  modalRoot: any;

  constructor(props: Props) {
    super(props);

    this.el = document.createElement("div");
    this.modalRoot = document.getElementById("modal-root");
  }

  componentDidMount() {
    this.modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    this.modalRoot.removeChild(this.el);
  }

  render() {
    const modal = this.props.children;
    return ReactDOM.createPortal(modal, this.el);
  }
}

export default renderModal;
